<template>
  <div class="viewer">
    <VrPlayer class="vr-player" v-bind="$attrs"></VrPlayer>
  </div>
</template>
<script>
import VrPlayer from "@/components/VrPlayer.vue";

export default {
  name: "Viewer",
  components: {
    VrPlayer,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped lang="scss">
.vr-player {
  width: 80%;
  height: 600px;
}
</style>
